import { Amplify } from "aws-amplify";
import config from "./aws-exports.js";

Amplify.configure(config);
